module.exports = __webpack_public_path__ + "img/insurance.ac66e5a4.svg";